import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import LearningCollectionEditStore from '../../../Store';
import { CustomizeState } from '../../../Store/Types';
import ProgramsState from './ProgramsState';

interface Props {
  store: LearningCollectionEditStore;
  state: CustomizeState;
}

function Programs({ store, state }: Props) {
  return (
    <div className="mb-40">
      <div className="mb-5 mt-10">
        <h1 className="text-[22px] font-semibold">
          <T kind="Programs" />
        </h1>
        <p className="mt-4">
          <T kind="Programs contain the core learning content consumed by..." />
        </p>
      </div>
      <ProgramsState store={store} state={state} />
    </div>
  );
}

export default observer(Programs);
